import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import AssetDepreciation from '@/types/table/assetDepreciation';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface AssetDepreciationData extends AssetDepreciation {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class AssetDepreciationController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetDepreciationData>>(
      API_CONTEXT + '/asset/assetDepreciation/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<AssetDepreciationData>(
      API_CONTEXT + '/asset/assetDepreciation/view',
      params,
      httpOptions,
    );
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/asset/assetDepreciation/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/asset/assetDepreciation/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/asset/assetDepreciation/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetDepreciation/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetDepreciation/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetDepreciation/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetDepreciation/deleteBatch', params, httpOptions);
  }
}
